import ChessImg from 'assets/chess.jpeg';
import MancalaImg from 'assets/mancala.jpeg';
import TravelImg from 'assets/travel.jpeg';
import ludoFamilyImg from 'assets/products/ludo-family.jpeg';
import ludoImg from 'assets/products/ludo.jpeg';
import carromImg from 'assets/products/carrom.png';
import towerImg from 'assets/products/tower.jpeg';
import dominoesImg from 'assets/products/dominoes.jpeg';
import backgammonImg from 'assets/products/backgammon.png';
import ticTacToeImg from 'assets/products/tic-tac-toe.jpeg';
import foxImg from 'assets/products/fox.jpeg';

export const PRODUCTS = [
  {
    id: 'chess-mahogany',
    name: 'Chess Set – Mahogany',
    category: 'classic',
    priceUGX: 220000,
    tags: ['2-Player', 'Mahogany', 'Hand-polished'],
    material: 'Mahogany wood, felt bases',
    size: 'Board 40cm, Staunton pieces',
    leadTimeDays: 3,
    image: ChessImg,
    description:
      'Premium mahogany chess set with weighted pieces and felt bottoms. Built for everyday play and heirloom vibes.',
    featured: true,
  },
  {
    id: 'chess-travel',
    name: 'Travel Chess – Foldable',
    category: 'travel',
    priceUGX: 120000,
    tags: ['Portable', 'Magnets', '2-Player'],
    material: 'Mugavu frame, magnetic steel sheet inlay',
    size: 'Folded 22cm',
    leadTimeDays: 2,
    image: TravelImg,
    description:
      'Compact, magnetic travel chess set—perfect for cafés, taxis, and road trips from Kampala to Entebbe.',
    featured: true,
  },
  {
    id: 'ludo-classic',
    name: 'Ludo – Family Board',
    category: 'party',
    priceUGX: 90000,
    tags: ['4-Player', 'Family', 'Color inlay'],
    material: 'Pine core with hardwood veneer',
    size: 'Board 45cm',
    leadTimeDays: 2,
    image: ludoFamilyImg,
    description:
      'Our best-selling Ludo board with crisp color inlays and smooth finish. Built for loud, happy game nights.',
  },
  {
    id: 'omweso',
    name: 'Omweso (Mancala) – Mugavu',
    category: 'ancient',
    priceUGX: 160000,
    tags: ['Cultural', 'Strategy', '2-4 Players'],
    material: 'Mugavu (Cordia africana)',
    size: 'Board 52cm (foldable), seeds included',
    leadTimeDays: 3,
    image: MancalaImg,
    description:
      'Traditional Omweso/Mancala crafted in Mugavu with smooth cups and concealed hinge. Proudly Ugandan.',
    featured: true,
  },
  {
    id: 'carrom',
    name: 'Carrom – Pro Smooth',
    category: 'party',
    priceUGX: 300000,
    tags: ['4-Player', 'Tournament feel'],
    material: 'Plywood top, hardwood frame',
    size: 'Board 74cm',
    leadTimeDays: 5,
    image: carromImg,
    description:
      'Pro-feel Carrom board with slick surface and sturdy corners. Includes striker and coins set.',
  },
  {
    id: 'jenga',
    name: 'Jenga Tower – Hardwood',
    category: 'party',
    priceUGX: 70000,
    tags: ['Party', 'Family', 'Kids'],
    material: 'Mixed hardwoods',
    size: '54 blocks',
    leadTimeDays: 1,
    image: towerImg,
    description:
      'Party starter! Precision-cut wooden blocks with a buttery sanded finish for satisfying pulls.',
  },
  {
    id: 'dominoes',
    name: 'Dominoes – Wooden Tiles',
    category: 'classic',
    priceUGX: 85000,
    tags: ['Classic', 'Tiles'],
    material: 'Hardwood tiles, engraved pips',
    size: '28 tiles + box',
    leadTimeDays: 2,
    image: dominoesImg,
    description: 'Weighted wooden dominoes with crisp engraving, housed in a snug wooden box.',
  },
  {
    id: 'backgammon',
    name: 'Backgammon – Inlay Board',
    category: 'classic',
    priceUGX: 240000,
    tags: ['2-Player', 'Inlay'],
    material: 'Mixed hardwood inlay',
    size: 'Board 45cm (foldable)',
    leadTimeDays: 4,
    image: backgammonImg,
    description:
      'Classic Backgammon with hardy inlay triangles, felted checkers, and smooth dice rolls.',
  },
  {
    id: 'tic-mini',
    name: 'Tic-Tac-Toe – Mini Travel',
    category: 'travel',
    priceUGX: 25000,
    tags: ['Kids', 'Pocket-size'],
    material: 'Pine/Mugavu mix',
    size: '10cm pocket board',
    leadTimeDays: 1,
    image: ticTacToeImg,
    description: 'Tiny pocket Tic-Tac-Toe that lives in your bag. Great for kids and café tables.',
  },
  {
    id: 'fox-geese',
    name: 'Fox & Geese – Strategy',
    category: 'classic',
    priceUGX: 95000,
    tags: ['2-Player', 'Historic'],
    material: 'Hardwood board + pegs',
    size: '30cm board',
    leadTimeDays: 3,
    image: foxImg,
    description:
      'Old-world asymmetric strategy game. Simple rules, deep traps—perfect for thinkers.',
  },
  {
    id: 'custom-engraved-ludo',
    name: 'Custom Engraved Ludo',
    category: 'custom',
    priceUGX: 140000,
    tags: ['Personalised', 'Gift'],
    material: 'Hardwood veneer + laser engraving',
    size: '45cm board',
    leadTimeDays: 5,
    image: ludoImg,
    description: 'Add your family name or logo. We engrave, finish, and deliver within Kampala.',
    featured: true,
  },
  //   {
  //     id: 'corporate-set',
  //     name: 'Corporate Gift Set',
  //     category: 'custom',
  //     priceUGX: 380000,
  //     tags: ['Bulk', 'Branding'],
  //     material: 'Mixed hardwoods + packaging',
  //     size: 'Bundle options',
  //     leadTimeDays: 7,
  //     image: ChessImg,
  //     description: 'Curated game bundles with your branding—perfect for client gifting and events.',
  //   },
];
